<!-- Notifications toggle -->
<button
mat-icon-button
(click)="openPanel()"
#notificationsOrigin
class="button-icon">
    @if (unreadCount > 0) {
        <span
            class="absolute left-0 right-0 top-0 flex h-3 items-center justify-center"
        >
            <span
                class="ml-xl mt-xs flex h-base min-w-base shrink-0 items-center justify-center rounded-full bg-error-500 px-1 text-sm font-medium text-accent-50"
            >
                {{ unreadCount }}
            </span>
        </span>
    }
    <i class="hgi-stroke hgi-notification-02"></i>
</button>

<!-- Notifications panel -->
<ng-template #notificationsPanel>
    <div
        class="notification-container"
    >
        <!-- Header -->
        <div
            class="notification-header "
        >
            <div class="-ml-1 mr-3 sm:hidden">
                <button mat-icon-button (click)="closePanel()">
                    <mat-icon
                        class="text-current icon-size-md"
                        [svgIcon]="'heroicons_solid:x-mark'"
                    ></mat-icon>
                </button>
            </div>
            <h5 class="mb-0">Notificaciones</h5>
            <div class="ml-auto">
                <button
                    class="button-icon fuse-mat-button-small"
                    mat-icon-button
                    [matTooltip]="'Marcar como leídas'"
                    [disabled]="unreadCount === 0"
                    (click)="markAllAsRead()"
                >
                    <i class="hgi-stroke hgi-mail-open-01"></i>
                </button>
            </div>
        </div>

        <!-- Content -->
        <div
            class="notification-body"
        >
            <!-- Notifications -->
            @for (
                notification of notifications;
                track trackByFn($index, notification)
            ) {
                <div
                    class="notification-body-content group hover:bg-primary-1000"
                    [ngClass]="{ unread: !notification.read }"
                >

                    <!-- Actions -->
                    <div class="notification-actions">

                        @if(!notification.read) {
                            <button
                                class="h-6 min-h-6 w-6"
                                mat-icon-button
                                (click)="toggleRead(notification)"
                                [matTooltip]="'Mark as read'"
                            >
                                <span
                                    class="h-2 w-2 rounded-full"
                                    [ngClass]="{
                                        'bg-gray-400 dark:bg-gray-500 sm:opacity-0 sm:group-hover:opacity-100':
                                            notification.read,
                                        'bg-primary': !notification.read,
                                    }"
                                ></span>
                            </button>
                        } @else {
                            <div class="min-w-6 min-h-6"></div>
                        }
                    </div>
                    <!-- Notification with a link -->
                    @if (notification.link) {

                        <!-- Normal links -->
                        @if (!notification.useRouter) {
                            <a
                                class="notification-link "
                                [href]=""
                                (click)="goTo($event, notification)"
                            >
                                <ng-container
                                    *ngTemplateOutlet="notificationContent"
                                ></ng-container>
                            </a>
                        }
                        <!-- Router links -->
                        @if (notification.useRouter) {
                            <a
                                class="notification-link"
                                [routerLink]="notification.link"
                            >
                                <ng-container
                                    *ngTemplateOutlet="notificationContent"
                                ></ng-container>
                            </a>
                        }
                    }

                    <!-- Notification without a link -->
                    @if (!notification.link) {
                        <div class="notification-no-link">
                            <ng-container
                                *ngTemplateOutlet="notificationContent"
                            ></ng-container>
                        </div>
                    }

                </div>

                <!-- Notification content template -->
                <ng-template #notificationContent>
                    <!-- MVP Version -->
                    <!-- Icon -->
                    <!-- @if (notification.icon && !notification.image) {
                        <div
                            class="mr-4 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700"
                        >
                            <mat-icon
                                class="icon-size-md"
                                [svgIcon]="notification.icon"
                            >
                            </mat-icon>
                        </div>
                    } -->
                    <!-- Image -->
                    @if (notification.image) {
                        <img
                            class="mr-4 h-8 w-8 shrink-0 overflow-hidden rounded-full object-cover object-center"
                            [src]="notification.image"
                            [alt]="'Notification image'"
                        />
                    }
                    <!-- Title, description & time -->
                    <div class="notification-content-text-container">
                        @if (notification.title) {
                            <div
                                class="notification-content-text-title "
                                [innerHTML]="notification.title"
                            ></div>
                        }
                        @if (notification.description) {
                            <div
                            class="notification-content-text-description"
                            [innerHTML]="notification.description"></div>
                        }
                        <div class="notification-content-text-date">
                            {{ notification.time | mediumDate }}
                        </div>
                    </div>
                </ng-template>
            }

            <!-- No notifications -->
            @if (!notifications || !notifications.length) {
                <div
                    class="notifications-no-data-container justify-center sm:justify-start"
                >
                    <!-- <div
                        class="flex h-14 w-14 flex-0 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-600"
                    >
                        <mat-icon
                            class="text-primary-700 dark:text-primary-50"
                            [svgIcon]="'heroicons_outline:bell'"
                        ></mat-icon>
                    </div> -->
                    <div class="notifications-no-data-title">
                        No tienes notificaciones
                    </div>
                    <div
                        class="notifications-no-data-description"
                    >

                        Todas las notificaciones, podrás verlas aquí.
                    </div>
                </div>
            }
        </div>
    </div>
</ng-template>
